/**
 * Caregiver Mode
 */
export enum CaregiverMode {
  _None = 'none',
  Informal = 'informal',
  Professional = 'professional',
  SystemAdministrator = 'system-administrator',
  Partner = 'partner',
}
